const queries = [
  {
    id: 'simple-query',
    language: 'graphql',
    title: 'Simple query',
    description: 'Fetch one or multiple content nodes in one GraphQL query.',
    children: `query {
  products {
    id
    title
    slug
    price
    onSale
    categories {
      id
      title
      slug
    }
    images {
      url
      width
      height
    }
  }
}`,
  },
  {
    id: 'union-query',
    language: 'graphql',
    title: 'Union Type query',
    description: 'Fetch one or multiple content nodes in one GraphQL query.',
    children: `query {
  property {
    ... on Hotel {
      pricePerNight
      suite
    }

    ... on House {
      rentPerMonth
      numberOfBeds
    }
    
    ... on Flat {
      pricePerMonth
      numberOfBeds
      allowsPets
    }
  }
}`,
  },
];

export default queries;
